import _regeneratorRuntime from 'babel-runtime/regenerator';
var _this = this;
function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }
        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }
      return step("next");
    });
  };
}
import level2SubscriptionService from '../../services/subscriptions/level2SubscriptionService';
export var UNSUBSCRIBE_LEVEL2 = 'UNSUBSCRIBE_LEVEL2';
export var GET_ALL_LEVEL_2_DATA = 'GET_ALL_LEVEL_2_DATA';
export var LEVEL_2_UPDATES = 'LEVEL_2_UPDATES';
export var REQUEST_LEVEL_2_DATA = 'REQUEST_LEVEL_2_DATA';

/**
 * Singleton for level2 subscription 'visibilitychange' listeners.
 * Named function required for removeEventListener.
 */
var mountedVisibilityListener = void 0;

/**
 * 1) Tell server to subscribe to level2 data for passed `instrumentId`
 * 2) Get first portion of data
 */
export var getLevel2Data = function getLevel2Data(instrumentId) {
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch) {
      var updates;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch(requestLevel2Data(instrumentId));
              _context.next = 3;
              return level2SubscriptionService.initSubscribtion(instrumentId);
            case 3:
              updates = _context.sent;
              mountedVisibilityListener = function mountedVisibilityListener() {
                return focusOutListener(instrumentId, dispatch);
              };
              document.addEventListener('visibilitychange', mountedVisibilityListener);
              if (updates.result !== false) {
                dispatch(getAllLevel2(updates));
              }
            case 7:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
var unsubbed = void 0;
function focusInListener(instrumentId, dispatch) {
  if (!document.hidden && unsubbed) {
    unsubbed = false;
    dispatch(getLevel2Data(instrumentId));
    document.removeEventListener('visibilitychange', mountedVisibilityListener);
  }
}
function focusOutListener(instrumentId, dispatch) {
  if (document.hidden && !unsubbed) {
    unsubbed = true;

    // Stop subscription while in other tab.
    dispatch(unsubscribeLevel2(instrumentId));
    document.removeEventListener('visibilitychange', mountedVisibilityListener);
    mountedVisibilityListener = function mountedVisibilityListener() {
      return focusInListener(instrumentId, dispatch);
    };
    document.addEventListener('visibilitychange', mountedVisibilityListener);
  }
}

/**
 * Add listener for level2 updates
 */
export var subscribeToLevel2 = function subscribeToLevel2() {
  return function (dispatch, getState) {
    level2SubscriptionService.subscribe(function (updates) {
      if (updates && updates[0] && updates[0].ProductPairCode === getState().apexCore.instrument.selectedInstrumentId) {
        dispatch(level2Updates(updates));
      }
    });
  };
};

/**
 * Stop getting updates from server for passed `insrtumentId`
 */
export var unsubscribeLevel2 = function unsubscribeLevel2(instrumentId) {
  return function (dispatch) {
    document.removeEventListener('visibilitychange', mountedVisibilityListener);
    level2SubscriptionService.stopOne(instrumentId);
    dispatch({
      type: UNSUBSCRIBE_LEVEL2
    });
  };
};
export var unsubscribeAllLevel2 = function unsubscribeAllLevel2() {
  return function (dispatch) {
    level2SubscriptionService.stopAll();
  };
};
export function getAllLevel2(updates) {
  return {
    type: GET_ALL_LEVEL_2_DATA,
    payload: updates
  };
}
export var requestLevel2Data = function requestLevel2Data(instrumentId) {
  return {
    type: REQUEST_LEVEL_2_DATA,
    payload: instrumentId
  };
};
export function level2Updates(updates) {
  return {
    type: LEVEL_2_UPDATES,
    payload: updates
  };
}